import segmentPlugin from '@analytics/segment'
import Analytics from 'analytics'

import { AnalyticsAction, AnalyticsPageAction, AnalyticsTrackAction, AnalyticsActionType } from 'types/analytics.type'
import { excludeFalsy, isString } from 'utils/common'

export const analytics = Analytics({
  app: 'nma-home',
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_SEGMENT_ANALYTICS_KEY,
    }),
  ].filter(excludeFalsy),
})
export const reset = () => {
  analytics.reset()
}

const getAnalyticsTenantAzId = () => analytics?.getState()?.user?.traits?.tenantAzId

const trackPage = ({ payload }: AnalyticsPageAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    analytics.page(
      {
        title: payload,
      },
      {
        agency: analyticsTenantAzId,
      },
    )
  }
}

const trackAction = ({ payload }: AnalyticsTrackAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    if (isString(payload)) {
      analytics.track(payload, {
        agency: analyticsTenantAzId,
      })
    } else {
      const { action, params } = payload

      analytics.track(action, {
        agency: analyticsTenantAzId,
        ...Object.fromEntries(params.map(({ key, value }) => [key, value])),
      })
    }
  }
}

export const trackAnalytics = (action: AnalyticsAction) => {
  switch (action.type) {
    case AnalyticsActionType.page:
      trackPage(action)
      break

    case AnalyticsActionType.action:
      trackAction(action)
      break

    default:
      break
  }
}

export const ANALYTICS_EVENTS = {
  PAGEVIEW: {
    LANDING: 'pg_pv_nmalanding',
  },
  ACTION: {
    HEADER_VIDEO_VIEW: 'pg_act_nma_header_viewvideo',
    HEADER_SUBMIT_WORK: 'pg_act_nma_header_submityourwork',
    NEED_TO_KNOW_GENERAL_INFO: 'pg_act_nma_landing_everythingyouneed_generalinformation',
    NEED_TO_KNOW_CATEGORIES: 'pg_act_nma_landing_everythingyouneed_categories',
    NEED_TO_KNOW_SUBMISSION_PROCESS: 'pg_act_nma_landing_everythingyouneed_submissionprocess',
    NEED_TO_KNOW_JUDGING_PROCESS: 'pg_act_nma_landing_everythingyouneed_judgingprocess',
    NEED_TO_KNOW_AWARDS_RECOGNITION: 'pg_act_nma_landing_everythingyouneed_awards&recognition',
    NEED_TO_KNOW_TECH_ISSUES_SUPPORT: 'pg_act_nma_landing_everythingyouneed_technicalissues&support',
    NEED_TO_KNOW_PEOPLES_VOTE: 'pg_act_nma_landing_everythingyouneed_peoplesvote',
    OPEN_INTERCOM: 'pg_act_nma_landing_openintercom',
    CONTACT_US: 'pg_act_nma_landing_contactus',
    VIEW_ALL_SUBMISSIONS: 'pg_act_nma_nmasubmissions_viewallsubmissions',
    PRODUCT_EXPERIENCE_ENTRY_FORM_DOWNLOAD: 'pg_act_nma_categories_productexperience_sampleentryfrom',
    LIVE_EXPERIENCE_ENTRY_FORM_DOWNLOAD: 'pg_act_nma_categories_liveexperiences_sampleentryfrom',
    DIGITAL_EXPERIENCE_ENTRY_FORM_DOWNLOAD: 'pg_act_nma_categories_digitalexperience_sampleentryfrom',
    RETAIL_EXPERIENCE_ENTRY_FORM_DOWNLOAD: 'pg_act_nma_categories_retailexperience_sampleentryfrom',
    CREATIVITY_ENTRY_FORM_DOWNLOAD: 'pg_act_nma_categories_mindblowingcreativity_sampleentryfrom',
    INNOVATION_ENTRY_FORM_DOWNLOAD: 'pg_act_nma_categories_innovation_sampleentryfrom',
    SCALED_IDEAS_ENTRY_FORM_DOWNLOAD: 'pg_act_nma_categories_scaledideas_sampleentryfrom',
    TRANSFORMATION_CATALYST_ENTRY_FORM_DOWNLOAD: 'pg_act_nma_categories_transformationcatalyst_sampleentryfrom',
    CATEGORIES_SUBMIT: 'pg_act_nma_categories_submit',
  },
}
